import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useDiscountCodesQuery } from "@ticketingplatform/api/dist/discountCode";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { useAutoComplete } from "hooks/useAutoComplete";
import { useVenueContext } from "contexts/VenueContext";
import { useMemo } from "react";

import { UseDiscountCodeSelect } from "./types";

export const useDiscountCodeSelect: UseDiscountCodeSelect = (props) => {
  const { venue } = useVenueContext();
  const [searchValue, debouncedSearch, onSearch] = useDebouncedValue<
    string | undefined
  >(undefined, 1000);

  const { data, loading } = useDiscountCodesQuery(
    useMemo(
      () => ({
        variables: {
          orderBy: [{ name: SortDirection.asc }],
          take: 10,
          filters: {
            ...(venue ? { venueId: { equals: venue.id } } : {}),
            ...(debouncedSearch
              ? {
                  name: {
                    contains: debouncedSearch,
                    mode: QueryMode.insensitive,
                  },
                }
              : {}),
            OR: [
              {
                expireAt: null,
              },
              {
                expireAt: {
                  gt: new Date(),
                },
              },
            ],
          },
        },
      }),
      [debouncedSearch, venue]
    )
  );

  return useAutoComplete({
    ...props,
    loading,
    searchValue,
    onSearch,
    options: data?.discountCodes?.nodes || [],
    valueProp: "id",
    labelProp: "name",
  });
};
